var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C6.46875 0 5.625 0.84375 5.625 1.875V28.125C5.625 29.1563 6.46875 30 7.5 30H26.25C27.2813 30 28.125 29.1563 28.125 28.125V7.5L20.625 0H7.5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.5H28.125L20.625 0V5.625C20.625 6.65625 21.4687 7.5 22.5 7.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 13.125L22.5 7.5H28.125V13.125Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 24.375C24.375 24.8906 23.9531 25.3125 23.4375 25.3125H2.8125C2.29687 25.3125 1.875 24.8906 1.875 24.375V15C1.875 14.4844 2.29687 14.0625 2.8125 14.0625H23.4375C23.9531 14.0625 24.375 14.4844 24.375 15V24.375Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96191 17.7629C5.96191 17.5154 6.15691 17.2454 6.47098 17.2454H8.20254C9.17754 17.2454 10.055 17.8979 10.055 19.1485C10.055 20.3335 9.17754 20.9935 8.20254 20.9935H6.95098V21.9835C6.95098 22.3135 6.74098 22.5 6.47098 22.5C6.22348 22.5 5.96191 22.3135 5.96191 21.9835V17.7629ZM6.95098 18.1894V20.0569H8.20254C8.70504 20.0569 9.10254 19.6135 9.10254 19.1485C9.10254 18.6244 8.70504 18.1894 8.20254 18.1894H6.95098ZM11.5232 22.5C11.2757 22.5 11.0057 22.365 11.0057 22.036V17.7779C11.0057 17.5088 11.2757 17.3129 11.5232 17.3129H13.2397C16.6654 17.3129 16.5904 22.5 13.3072 22.5H11.5232ZM11.9957 18.2279V21.586H13.2397C15.2638 21.586 15.3538 18.2279 13.2397 18.2279H11.9957ZM17.8054 18.2879V19.4794H19.7169C19.9869 19.4794 20.2569 19.7494 20.2569 20.011C20.2569 20.2585 19.9869 20.461 19.7169 20.461H17.8054V22.035C17.8054 22.2975 17.6188 22.4991 17.3563 22.4991C17.0263 22.4991 16.8247 22.2975 16.8247 22.035V17.7769C16.8247 17.5079 17.0272 17.3119 17.3563 17.3119H19.9879C20.3179 17.3119 20.5129 17.5079 20.5129 17.7769C20.5129 18.0169 20.3179 18.2869 19.9879 18.2869H17.8054V18.2879Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 25.3125H5.625V26.25H23.4375C23.9531 26.25 24.375 25.8281 24.375 25.3125V24.375C24.375 24.8906 23.9531 25.3125 23.4375 25.3125Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.e6501f220fb02bcfa48b0f2676600339.svg";
export { ForwardRef as ReactComponent };